import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';

type JqModule = { json: (input: unknown, filter: string) => unknown };

let jqPromise: Promise<JqModule> | null = null;

export const applyJqProgram = async (
  canonical: Record<string, unknown>,
  jqProgram: string,
): Promise<Record<string, unknown>> => {
  try {
    const jq = await getJq();
    return (await jq.json(canonical, jqProgram)) as Record<string, unknown>;
  } catch {
    return applyJqProgramFallback(canonical, jqProgram);
  }
};

const getJq = () => {
  if (!jqPromise) {
    jqPromise = import('jq-wasm') as Promise<JqModule>;
  }
  return jqPromise;
};

const assignmentRegex = /^(.+?)\s*=\s*(.+)$/;

const applyJqProgramFallback = (canonical: Record<string, unknown>, jqProgram: string): Record<string, unknown> => {
  const result = cloneDeep(canonical);

  const assignments = jqProgram.split('|').map((s) => s.trim());

  for (const assignment of assignments) {
    const match = assignment.match(assignmentRegex);
    if (!match) {
      continue;
    }

    const matchedPath = match[1]
      .trim()
      .replace(/^\./, '')
      .replace(/\[(\d+)]/g, '.$1');
    const matchedValue = parseValue(match[2]);
    set(result, matchedPath, matchedValue);
  }

  return result;
};

const parseValue = (raw: string): string | number => {
  const trimmed = raw.trim();

  const isQuoted = trimmed.startsWith('"') && trimmed.endsWith('"');
  if (isQuoted) {
    const unquoted = trimmed.slice(1, -1);
    return unquoted;
  }

  const num = Number(trimmed);
  return Number.isNaN(num) ? trimmed : num;
};
